export default "__VITE_ASSET__FuN2cU3O__"